export default {
  data() {
    return {
      postalRequired: [
        {
          long_name: "Algeria",
          code: "DZA"
        },
        {
          long_name: "Argentina",
          code: "ARG"
        },
        {
          long_name: "Armenia",
          code: "ARM"
        },
        {
          long_name: "Australia",
          code: "AUS"
        },
        {
          long_name: "Austria",
          code: "AUT"
        },
        {
          long_name: "Azerbaijan",
          code: "AZE"
        },
        {
          long_name: "Bangladesh",
          code: "BGD"
        },
        {
          long_name: "Belarus",
          code: "BLR"
        },
        {
          long_name: "Belgium",
          code: "BEL"
        },
        {
          long_name: "Bosnia",
          code: "BIH"
        },
        {
          long_name: "Brazil",
          code: "BRA"
        },
        {
          long_name: "Brunei",
          code: "BRN"
        },
        {
          long_name: "Bulgaria",
          code: "BGR"
        },
        {
          long_name: "Canada",
          code: "CAN"
        },
        {
          long_name: "China, People's Republic of",
          code: "CHN"
        },
        {
          long_name: "Croatia",
          code: "HRV"
        },
        {
          long_name: "Cyprus",
          code: "CYP"
        },
        {
          long_name: "Czech Republic",
          code: "CZE"
        },
        {
          long_name: "Denmark",
          code: "DNK"
        },
        {
          long_name: "Estonia",
          code: "EST"
        },
        {
          long_name: "Faeroe Islands",
          code: "FRO"
        },
        {
          long_name: "Finland",
          code: "FIN"
        },
        {
          long_name: "France",
          code: "FRA"
        },
        {
          long_name: "Georgia",
          code: "GEO"
        },
        {
          long_name: "Germany",
          code: "DEU"
        },
        {
          long_name: "Greece",
          code: "GRC"
        },
        {
          long_name: "Greenland",
          code: "GRL"
        },
        {
          long_name: "Guam",
          code: "GUM"
        },
        {
          long_name: "Guernsey",
          code: "GGY"
        },
        {
          long_name: "Hungary",
          code: "HUN"
        },
        {
          long_name: "India",
          code: "IND"
        },
        {
          long_name: "Indonesia",
          code: "IDN"
        },
        {
          long_name: "Israel",
          code: "ISR"
        },
        {
          long_name: "Italy",
          code: "ITA"
        },
        {
          long_name: "Japan",
          code: "JPN"
        },
        {
          long_name: "Jersey",
          code: "JEY"
        },
        {
          long_name: "Kazakhstan",
          code: "KAZ"
        },
        {
          long_name: "Kyrgyzstan",
          code: "KGZ"
        },
        {
          long_name: "Latvia",
          code: "LVA"
        },
        {
          long_name: "Liechtenstein",
          code: "LIE"
        },
        {
          long_name: "Lithuania",
          code: "LTU"
        },
        {
          long_name: "Luxembourg",
          code: "LUX"
        },
        {
          long_name: "Macedonia (FYROM)",
          code: "MKD"
        },
        {
          long_name: "Madagascar",
          code: "MDG"
        },
        {
          long_name: "Malaysia",
          code: "MYS"
        },
        {
          long_name: "Malta",
          code: "MLT"
        },
        {
          long_name: "Marshall Islands",
          code: "MHL"
        },
        {
          long_name: "Martinique",
          code: "MTQ"
        },
        {
          long_name: "Mayotte",
          code: "MYT"
        },
        {
          long_name: "Mexico",
          code: "MEX"
        },
        {
          long_name: "Moldova",
          code: "MDA"
        },
        {
          long_name: "Mongolia",
          code: "MNG"
        },
        {
          long_name: "Montenegro",
          code: "MNE"
        },
        {
          long_name: "Netherlands",
          code: "NLD"
        },
        {
          long_name: "New Zealand",
          code: "NZL"
        },
        {
          long_name: "Norway",
          code: "NOR"
        },
        {
          long_name: "Pakistan",
          code: "PAK"
        },
        {
          long_name: "Panama",
          code: "PAN"
        },
        {
          long_name: "Philippines",
          code: "PHL"
        },
        {
          long_name: "Poland",
          code: "POL"
        },
        {
          long_name: "Portugal",
          code: "PRT"
        },
        {
          long_name: "Puerto Rico",
          code: "PRI"
        },
        {
          long_name: "Reunion",
          code: "REU"
        },
        {
          long_name: "Russia",
          code: "RUS"
        },
        {
          long_name: "Saudi Arabia",
          code: "SAU"
        },
        {
          long_name: "Serbia",
          code: "SRB"
        },
        {
          long_name: "Singapore",
          code: "SGP"
        },
        {
          long_name: "Slovakia",
          code: "SVK"
        },
        {
          long_name: "Slovenia",
          code: "SVN"
        },
        {
          long_name: "South Africa",
          code: "ZAF"
        },
        {
          long_name: "South Korea",
          code: "KOR"
        },
        {
          long_name: "Spain",
          code: "ESP"
        },
        {
          long_name: "Sri Lanka",
          code: "LKA"
        },
        {
          long_name: "St. Barthelemy",
          code: "BLM"
        },
        {
          long_name: "Sweden",
          code: "SWE"
        },
        {
          long_name: "Switzerland",
          code: "CHE"
        },
        {
          long_name: "Taiwan",
          code: "TWN"
        },
        {
          long_name: "Tajikistan",
          code: "TJK"
        },
        {
          long_name: "Thailand",
          code: "THA"
        },
        {
          long_name: "Tunisia",
          code: "TUN"
        },
        {
          long_name: "Turkey",
          code: "TUR"
        },
        {
          long_name: "Turkmenistan",
          code: "TKM"
        },
        {
          long_name: "U.S. Virgin Islands",
          code: "VIR"
        },
        {
          long_name: "Ukraine",
          code: "UKR"
        },
        {
          long_name: "United Kingdom",
          code: "GBR"
        },
        {
          long_name: "United States",
          code: "USA"
        },
        {
          long_name: "Uruguay",
          code: "URY"
        },
        {
          long_name: "Uzbekistan",
          code: "UZB"
        },
        {
          long_name: "Vatican City State",
          code: "VAT"
        },
        {
          long_name: "Vietnam",
          code: "VNM"
        }
      ]
    }
  },
  methods: {
    isPostalCodeRequired(countryCode) {
      if (!countryCode) {
        return false;
      }

      return this.postalRequired.some(postalCode => postalCode.code === countryCode)
    },
  }
}
